<template>
  <div style="width:100%; height: 100%;">
    <div style="height: 100px; width: 100%; padding: 15px 400px;box-shadow: 0 0.08333rem 0.25rem 0 rgba(0, 0, 0, .08);">
      <el-steps :active="activeStep" finish-status="success">
        <el-step title="选择场景"></el-step>
        <el-step title="场景配置"></el-step>
        <el-step title="桌面资源计算"></el-step>
        <el-step title="服务器配置"></el-step>
        <el-step title="计算结果"></el-step>
      </el-steps>
    </div>
    <div
      id="divRef"
      style="width:100%; height: 96%; overflow-y: auto;padding: 20px;"
      ref="scrollContainer"
      @scroll="handleScroll"
    >
      <div style="width: 100%;background-color:rgba(0, 0, 0,0.05);padding: 5px;">
        <div class="gradient-border">
          <div style="width: 100%;">
            <h1 style="text-align: center;">VDI场景服务器资源配置器（试点）</h1>
          </div>
          <div style="width: 100%;">
            <h2>
              选择场景（<span style="color: orange;text-decoration: underline;" @click="showUseCalNotice()"
                >服务器资源配置器参考资料</span
              >） （<span style="color: orange;text-decoration: underline;" @click="showSpecialSceneCalType()"
                >共享应用虚拟化，共享桌面场景计算服务器资源请看这里！！！</span
              >）
            </h2>
            <h2>
              温馨提示：
              <span style="color: orange;">配置器暂时不支持计算资源不隔离的场景及混合场景，后续再迭代</span>
            </h2>
          </div>
          <el-form
            :model="firstForm"
            :rules="firstRules"
            ref="firstForm"
            label-position="right"
            label-width="100px"
            style="width: 100%;"
          >
            <el-form-item label="项目名称" prop="customerName" class="sky-calculator__form-item">
              <el-input v-model="firstForm.customerName" style="width: 30%;"></el-input>
            </el-form-item>
            <el-form-item label="行业选择" prop="industryId" class="sky-calculator__form-item">
              <el-radio-group v-model="firstForm.industryId" @change="changeTrade">
                <el-radio-button v-for="(radioItem, index) in specIndustryList" :key="index" :label="radioItem.id">{{
                  radioItem.industryName
                }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="场景选择" prop="sceneSegmentSceneDTOList" class="sky-calculator__form-item item">
              <sky-cal-scene-segment-scene-rela
                :value="firstForm.sceneSegmentSceneDTOList"
                :industryId="firstForm.industryId"
                :key="sceneComponentKey"
                @childSceneSegmentSceneRela="handleChildSceneSegmentSceneRela"
              ></sky-cal-scene-segment-scene-rela>
            </el-form-item>
            <el-form-item style="text-align: center;margin-left: -700px;">
              <el-button type="primary" @click="onSubmit('firstForm')">保存客户信息</el-button>
              <el-button
                class="el-button filter-item el-button--default el-button--mini"
                @click="gotoHomeServerOrderList"
                size="mini"
                >返回列表</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div style="width: 100%;">
        <el-tabs
          v-if="selectSegmentSceneList.length > 0"
          v-model="activeName"
          type="border-card"
          @tab-click="handleTabClick"
        >
          <el-tab-pane
            v-for="item in selectSegmentSceneList"
            :key="item.sceneName"
            :label="item.sceneName"
            :name="item.sceneName"
          >
            <el-form label-position="right" label-width="150px" class="sky-calculator__form" style="width: 100%">
              <div style="background-color:rgba(0, 0, 0,0.05);padding: 5px;">
                <div class="gradient-border" v-if="instCalServerElementDTOList.length > 0">
                  <div style="width: 100%;"><h2>场景配置</h2></div>
                  <div class="container" v-for="(item, index) in instCalServerElementDTOList" :key="index">
                    <el-form-item v-if="item.type === 'DOUBLE_SCREEN'" label="是否双屏" class="item">
                      <template slot="label">
                        <label style="color: red;">*</label>
                        <span>是否双屏</span
                        ><i class="el-icon-question" @click="showTipsQuestion('doubleScreen', '是否双屏')"></i
                      ></template>
                      <el-select v-model="item.content" placeholder="请选择">
                        <el-option label="仅单屏" value="false"></el-option>
                        <el-option label="要双屏" value="true"> </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.type === 'HIGH_IO'" label="是否读写高性能" class="item">
                      <template slot="label">
                        <label style="color: red;">*</label>
                        <span>是否读写高性能</span
                        ><i class="el-icon-question" @click="showTipsQuestion('highIo', '是否读写高性能')"></i
                      ></template>
                      <el-select
                        v-model="item.content"
                        placeholder="请选择"
                        @change="highIoChange(item.type, item.content)"
                      >
                        <el-option label="否" value="false"></el-option>
                        <el-option label="是" value="true"> </el-option>
                      </el-select>
                      <!-- <span style="color: orange; float:left;position:absolute;width: 800px; font-size: 10px;">
                        注：如果选择【是】，则使用当前磁盘1:6虚机的规则计算磁盘数量，如果不采用这个规则，则选择【否】,计算出服务器资源后，再通过
                        <a
                          href="https://ruijie.feishu.cn/wiki/QeDvwyIdniVaRMkopeMckwcQnfh"
                          target="_blank"
                          rel="noopener noreferrer"
                          >《存储配置使用手册》</a
                        >此文档微调磁盘数量</span
                      > -->
                    </el-form-item>
                    <el-form-item v-if="item.type === 'DESKTOP_TYPE'" label="桌面用途" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label> <span>桌面用途</span
                        ><i class="el-icon-question" @click="showTipsQuestion('desktopType', '桌面用途')"></i
                      ></template>
                      <el-select v-model="item.content" placeholder="请选择" @change="desktopTypeChange(item.content)">
                        <el-option label="还原桌面" value="RESTORE"></el-option>
                        <el-option label="个性桌面" value="SELFDOM"> </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.type === 'RENDERING'" label="渲染要求" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>渲染要求</span
                        ><i class="el-icon-question" @click="showTipsQuestion('rendering', '渲染要求')"></i
                      ></template>
                      <el-select
                        v-model="item.content"
                        placeholder="请选择"
                        @change="renderingChange(item.type, item.content)"
                      >
                        <el-option label="无需渲染" value="NO_NEED"> </el-option>
                        <el-option label="AMD显卡可以满足" value="LIGHT"></el-option>
                        <el-option label="要求NVIDIA显卡" value="WEIGHT"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item v-if="item.type === 'ANTIVIRUS_SOFTWARE'" label="杀毒软件" class="item">
                      <template slot="label"
                        ><span>杀毒软件</span
                        ><i class="el-icon-question" @click="showTipsQuestion('antivirusSoftware', '杀毒软件')"></i
                      ></template>
                      <el-select v-model="antivirusSoftwareIdArr" multiple placeholder="请选择">
                        <el-option
                          v-for="(obj, objIndex) in antivirusSoftwareList"
                          :key="objIndex"
                          :label="obj.softwareName"
                          :value="obj.id"
                        >
                        </el-option>
                      </el-select>
                      <span style="color: orange; float:left;position:absolute;width: 500px;font-size: 10px;">
                        注：有杀毒软件服务器带机量减少相应的并发量，如果有多款杀毒软件会叠加减少</span
                      >
                    </el-form-item>
                    <el-form-item v-if="item.type === 'ENCRPYTION_SOFTWARE'" label="加密软件" class="item">
                      <template slot="label"
                        ><span>加密软件</span
                        ><i class="el-icon-question" @click="showTipsQuestion('encrpytionSoftware', '加密软件')"></i
                      ></template>
                      <el-select v-model="encrpytionSoftwareId" clearable placeholder="请选择">
                        <el-option
                          v-for="(obj, objIndex) in encrpytionSoftwareList"
                          :key="objIndex"
                          :label="obj.softwareName"
                          :value="obj.id"
                        >
                        </el-option>
                      </el-select>
                      <span style="color: orange; float:left;position:absolute;width: 300px;font-size: 10px;">
                        注：有加密软件服务器带机量会减少相应的并发量</span
                      >
                    </el-form-item>
                  </div>
                </div>
                <div class="gradient-border">
                  <div style="width: 100%;">
                    <h2>
                      云桌面配置规格选型<span style="font-size: small; color: orange; float:left;position:absolute;">
                        （桌面、服务器CPU主频都是指的是正常主频,非睿频）</span
                      >
                    </h2>
                  </div>
                  <el-form-item label="桌面资源影响因子" prop="customerName">
                    <template slot="label"
                      ><label style="color: red;">*</label><span>桌面资源影响因子</span
                      ><i
                        class="el-icon-question"
                        @click="showTipsQuestion('desktopElementList', '桌面资源影响因子')"
                      ></i
                    ></template>
                    <el-table
                      :key="desktopElementComponentKey"
                      :data="specCalDesktopElementDTOList"
                      stripe
                      max-height="350"
                      style="width: 100%;height: 350px;"
                    >
                      <el-table-column prop="name" label="名称" width="180">
                        <template slot-scope="scope">
                          <div class="wsp-display-flex">
                            <div>{{ scope.row.name }}</div>
                            <el-tooltip
                              effect="dark"
                              :content="`点击移除桌面资源影响因子【${scope.row.name}】`"
                              placement="top-start"
                            >
                              <div
                                class="el-icon-error wsp-padding-left-5 wsp-line-height-24"
                                @click="removeDesktopElement(scope.row, scope.$index)"
                              ></div>
                            </el-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="softVersion" label="软件版本" width="180"> </el-table-column>
                      <el-table-column prop="typeDesc" label="元素类型"> </el-table-column>
                      <el-table-column prop="materialDesc" label="素材大小(MB)"> </el-table-column>
                      <el-table-column prop="cpuSpeed" label="CPU主频(GHZ)"> </el-table-column>
                      <el-table-column prop="cpuCore" label="CPU(核数)"> </el-table-column>
                      <el-table-column prop="videoMemory" label="GPU显存"> </el-table-column>
                      <el-table-column prop="memory" label="内存(G)"> </el-table-column>
                      <el-table-column prop="systemDiskSize" label="系统盘(G)"> </el-table-column>
                      <el-table-column prop="dataDiskSize" label="数据盘(G)"> </el-table-column>
                      <el-table-column prop="iops" label="iops"> </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-form-item prop="">
                    <el-button type="primary" @click="getDesktopElementList()">➕添加桌面资源影响因子</el-button>
                  </el-form-item>
                  <div style=" border-top: 0.8px solid rgba(0, 0, 0,0.05);;margin: 10px 0;"></div>
                  <el-form-item label="桌面模版列表" prop="desktopResourceList">
                    <template slot="label"
                      ><label style="color: red;">*</label><span>桌面模版列表</span
                      ><i class="el-icon-question" @click="showTipsQuestion('desktopResourceList', '桌面模版列表')"></i
                    ></template>
                    <el-table
                      class="cal-table"
                      :key="desktopResourceKey"
                      :data="instCalDesktopResourceDTOList"
                      stripe
                      style="width: 100%;height: 250"
                    >
                      <el-table-column style="height: 0rem;" prop="cpuSpeed" label="CPU主频(GHZ)">
                        <template slot-scope="scope">
                          <el-input-number
                            style="width:100%;height: 100%;"
                            v-model="scope.row.cpuSpeed"
                            :precision="2"
                            :step="0.1"
                            :min="1"
                            @change="selectOsType(item, scope.row)"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column prop="cpuCore" label="CPU(核数)">
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.cpuCore" :min="1" />
                        </template>
                      </el-table-column>
                      <el-table-column prop="videoMemory" label="GPU显存">
                        <template slot-scope="scope">
                          <el-input-number
                            v-model="scope.row.videoMemory"
                            :precision="2"
                            :step="0.1"
                            :min="0"
                            @change="videoMemoryChange(scope.row.videoMemory)"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column prop="memory" label="内存(G)">
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.memory" :min="1" />
                        </template>
                      </el-table-column>
                      <el-table-column prop="systemDiskSize" label="系统盘(G)">
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.systemDiskSize" :min="1" />
                        </template>
                      </el-table-column>
                      <el-table-column prop="dataDiskSize" label="数据盘(G)">
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.dataDiskSize" :min="1" />
                        </template>
                      </el-table-column>
                      <el-table-column prop="osTypeId" label="桌面操作系统" width="160%">
                        <template slot-scope="scope">
                          <el-select
                            v-model="scope.row.osTypeId"
                            placeholder="请选择系统"
                            style="width: 95%!important;border: 2px dashed orange;"
                            @change="selectOsType(item, scope.row)"
                          >
                            <el-option
                              v-for="(item, index) in osTypeList"
                              :key="index"
                              :label="item.osType"
                              :value="item.id"
                            >
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="desktopNum" label="桌面点数">
                        <template slot-scope="scope">
                          <el-input-number
                            v-model="scope.row.desktopNum"
                            :min="1"
                            style="width: 95%!important;border: 2px dashed orange;"
                            @change="desktopNumChange()"
                          />
                        </template>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <el-button type="primary" @click="copyDesktopResource(scope.row)">复制</el-button>
                          <el-button
                            v-if="scope.row.dataFrom === 'USER_ADD'"
                            type="error"
                            @click.native.prevent="deleteRow(scope.$index, instCalDesktopResourceDTOList)"
                            size="small"
                          >
                            移除
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                </div>
                <div class="gradient-border" v-if="isShowRadicalModelView">
                  <div style="width: 100%;">
                    <h2>
                      企业特殊配置
                    </h2>
                  </div>
                  <div class="container">
                    <el-form-item label="企业特殊配置" prop="isRadicalModel" class="item" style="width: 350px;">
                      <template slot="label"><span>超分比计算模式</span></template>
                      <el-radio-group v-model="isRadicalModel" style="width: 300px;">
                        <el-radio :label="false" size="large">普通模式</el-radio>
                        <el-radio :label="true" size="large">激进模式</el-radio>
                      </el-radio-group>
                      <span style="color: orange; float:left;position:absolute;width: 1000px;font-size: 16px;">
                        注意：如果场景点数200点以上并且客户采用分批上线的场景下；可选择【激进模式】，提升CPU超分比</span
                      >
                    </el-form-item>
                  </div>
                </div>
                <div class="gradient-border">
                  <div style="width: 100%;">
                    <h2>
                      服务器配置
                    </h2>
                  </div>
                  <div class="container">
                    <el-form-item label="服务器型号选择" prop="selectServerModel" class="item" style="width: 350px;">
                      <template slot="label"><span>服务器型号选择</span></template>
                      <el-radio-group
                        v-model="selectServerModel"
                        style="width: 300px;"
                        @change="selectServerModelChange"
                      >
                        <el-radio :label="single" size="large">手动选择服务器</el-radio>
                        <el-radio :label="all" size="large">系统推荐服务器</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                  <div v-show="isCalSingleServerVisible">
                    <div class="container">
                      <el-form-item label="服务器选择" prop="serverId" class="item">
                        <template slot="label"
                          ><span>服务器选择</span
                          ><i class="el-icon-question" @click="showTipsQuestion('calServer', '服务器')"></i
                        ></template>
                        <el-select
                          v-model="serverResourceDTO.serverId"
                          clearable
                          placeholder="请选择"
                          @change="selectServer"
                        >
                          <el-option
                            v-for="(item, index) in instCalRecommendServerDTOList"
                            :key="index"
                            :label="item.serverName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="GPU显卡选择" prop="dd" class="item">
                        <template slot="label"
                          ><span>GPU显卡选择</span
                          ><i class="el-icon-question" @click="showTipsQuestion('calServerGpu', 'GPU显卡')"></i
                        ></template>
                        <el-select v-model="selectGpu" clearable placeholder="请选择" @change="selectGpuChange">
                          <el-option
                            v-for="(item, index) in specCalGpuCardDTOList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="container">
                      <el-form-item label="CPU选择" prop="cpuConfigId" class="item">
                        <template slot="label"
                          ><span>CPU选择</span
                          ><i class="el-icon-question" @click="showTipsQuestion('calServerCpu', 'CPU')"></i
                        ></template>
                        <el-select v-model="serverResourceDTO.cpuConfigId" clearable placeholder="请选择">
                          <el-option
                            v-for="(item, index) in instCalRecommendCpuDTOList"
                            :key="index"
                            :label="item.cpuName"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="CPU数量" prop="cpuNum" class="item">
                        <el-select v-model="serverResourceDTO.cpuNum" placeholder="请选择" @change="selectCpuNumChange">
                          <el-option label="1" value="1"></el-option>
                          <el-option label="2" value="2"> </el-option>
                        </el-select>
                      </el-form-item>
                    </div>
                  </div>
                  <div v-show="isCalAllServerVisible" class="container">
                    <el-form-item label="CPU数量" prop="cpuNum" class="item">
                      <el-select v-model="serverResourceDTO.cpuNum" placeholder="请选择">
                        <el-option label="1" value="1"></el-option>
                        <el-option label="2" value="2"> </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="是否需要GPU" prop="dd" class="item">
                      <template slot="label"
                        ><span>是否需要GPU</span
                        ><i class="el-icon-question" @click="showTipsQuestion('calServerGpu', '是否需要显卡')"></i
                      ></template>
                      <el-select v-model="isNeedGpu" placeholder="请选择">
                        <el-option label="是" value="true"> </el-option>
                        <el-option label="否" value="false"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="container">
                    <el-form-item label="服务器系统盘规格" prop="serverSystemDiskType" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>服务器系统盘规格</span
                        ><i class="el-icon-question" @click="showTipsQuestion('serverSysDisk', '服务器系统盘规格')"></i
                      ></template>
                      <el-select v-model="serverSystemDiskType" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in specSsdDiskList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="服务器系统盘数量" prop="serverSystemDiskCount" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>服务器系统盘数量</span
                        ><i
                          class="el-icon-question"
                          @click="showTipsQuestion('serverSysDiskNumber', '服务器系统盘数量')"
                        ></i
                      ></template>
                      <el-select
                        v-model="serverSystemDiskCount"
                        placeholder="请选择"
                        @change="selectSystemDiskCountChange"
                      >
                        <el-option label="1" value="1"></el-option>
                        <el-option label="2" value="2"> </el-option>
                      </el-select>
                    </el-form-item>
                    <span v-if="raidTipsShow" style="color: red;width: 160px;">
                      注：若客户需要配置双系统盘，必须搭载硬件RAID卡！！！</span
                    >
                  </div>

                  <div class="container">
                    <el-form-item label="服务器缓存盘规格" prop="serverCacheDiskType" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>服务器缓存盘规格</span
                        ><i
                          class="el-icon-question"
                          @click="showTipsQuestion('serverCacheDisk', '服务器缓存盘规格')"
                        ></i
                      ></template>
                      <el-select v-model="serverCacheDiskType" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in specSsdDiskList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="服务器缓存盘数量" prop="serverCacheDiskCount" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>服务器缓存盘数量</span
                        ><i
                          class="el-icon-question"
                          @click="showTipsQuestion('serverCacheDiskNumber', '服务器缓存盘数量')"
                        ></i
                      ></template>
                      <el-select v-model="serverCacheDiskCount" placeholder="请选择">
                        <el-option label="1" value="1"> </el-option>
                        <el-option label="2" value="2"> </el-option>
                        <el-option label="3" value="3"> </el-option>
                        <el-option label="4" value="4"> </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <el-form-item label="内存条规格" prop="memorySpec">
                    <template slot="label"
                      ><label style="color: red;">*</label><span>内存条规格</span
                      ><i class="el-icon-question" @click="showTipsQuestion('memorySpec', '内存条规格')"></i
                    ></template>
                    <el-select v-model="memorySpec" placeholder="请选择">
                      <el-option label="32G" value="THIRTY_TWO"> </el-option>
                      <el-option label="64G" value="SIXTY_FOUR"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="isShowLocalDiskView" class="gradient-border">
                  <div style="width: 100%;">
                    <h2>
                      本地存储配置
                    </h2>
                  </div>
                  <div class="container">
                    <el-form-item label="本地磁盘规格" prop="localDiskType" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>本地磁盘规格</span
                        ><i class="el-icon-question" @click="showTipsQuestion('localDiskType', '本地磁盘规格')"></i
                      ></template>
                      <el-select v-model="localDiskType" placeholder="请选择" :key="localDiskComponent">
                        <el-option
                          v-for="(item, index) in specGroupDiskList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="产生数据大小(G)" prop="backUpType">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>产生数据大小(G)</span
                        ><i class="el-icon-question" @click="showTipsQuestion('generateSize', '产生数据大小')"></i
                      ></template>
                      <el-input-number v-model="generateSize" :min="0"></el-input-number>
                      <span style="color: orange; float:left;position:absolute;width: 800px; font-size: 15px;">
                        每次学生使用桌面产生的数据大小(G)</span
                      >
                    </el-form-item>
                  </div>
                </div>
                <div class="gradient-border">
                  <div style="width: 100%;">
                    <h2>
                      分布式存储配置
                    </h2>
                  </div>
                  <div class="container">
                    <el-form-item label="桌面系统盘规格" prop="desktopSystemDiskType" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>桌面系统盘规格</span
                        ><i class="el-icon-question" @click="showTipsQuestion('desktopSysDisk', '桌面系统盘规格')"></i
                      ></template>
                      <el-select v-model="desktopSystemDiskType" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in specDiskList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="副本策略" prop="backUpType">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>副本策略</span
                        ><i class="el-icon-question" @click="showTipsQuestion('replicationStrategy', '副本策略')"></i
                      ></template>
                      <el-select v-model="desktopSystemDiskBackUpType" placeholder="请选择">
                        <el-option label="系统推荐(按节点推荐最可靠的副本策略)" value="SYSTEM_RECOMMEND" selected>
                        </el-option>
                        <el-option label="2D(服务器最少需要3节点)" value="TWO_D"> </el-option>
                        <el-option label="2D1P(服务器最少需要4节点)" value="TWO_D_ONE_P"></el-option>
                        <el-option label="3D(服务器最少需要4节点)" value="THREE_D"></el-option>
                        <el-option label="4D1P(服务器最少需要6节点)" value="FOUR_D_ONE_P"></el-option>
                        <el-option label="4D2P(服务器最少需要7节点)" value="FOUR_D_TWO_P"></el-option>
                        <el-option label="8D2P(服务器最少需要11节点)" value="EIGHT_D_TWO_P"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="container">
                    <el-form-item label="桌面数据盘规格" prop="desktopDataDiskType" class="item">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>桌面数据盘规格</span
                        ><i class="el-icon-question" @click="showTipsQuestion('desktopDataDisk', '桌面数据盘规格')"></i
                      ></template>
                      <el-select v-model="desktopDataDiskType" placeholder="请选择">
                        <el-option
                          v-for="(item, index) in specDiskList"
                          :key="index"
                          :label="item.label"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="副本策略" prop="backUpType">
                      <template slot="label"
                        ><label style="color: red;">*</label><span>副本策略</span
                        ><i class="el-icon-question" @click="showTipsQuestion('replicationStrategy', '副本策略')"></i
                      ></template>
                      <el-select v-model="desktopDataDiskBackUpType" placeholder="请选择">
                        <el-option label="系统推荐(按节点推荐最可靠的副本策略)" value="SYSTEM_RECOMMEND" selected>
                        </el-option>
                        <el-option label="2D(服务器最少需要3节点)" value="TWO_D"> </el-option>
                        <el-option label="2D1P(服务器最少需要4节点)" value="TWO_D_ONE_P"></el-option>
                        <el-option label="3D(服务器最少需要4节点)" value="THREE_D"></el-option>
                        <el-option label="4D1P(服务器最少需要6节点)" value="FOUR_D_ONE_P"></el-option>
                        <el-option label="4D2P(服务器最少需要7节点)" value="FOUR_D_TWO_P"></el-option>
                        <el-option label="8D2P(服务器最少需要11节点)" value="EIGHT_D_TWO_P"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div class="gradient-border">
                  <div style="width: 100%;">
                    <h2>
                      集群公共配置
                    </h2>
                  </div>
                  <el-form-item label="CMS云盘大小(G)" prop="cmsSize">
                    <template slot="label"
                      ><label style="color: red;">*</label><span>CMS云盘大小(G)</span
                      ><i class="el-icon-question" @click="showTipsQuestion('cms', 'CMS云盘大小')"></i
                    ></template>
                    <el-input-number v-model="cmsSize" :min="0"></el-input-number>
                  </el-form-item>
                  <el-form-item label="是否高可用">
                    <template slot="label"
                      ><label style="color: red;">*</label><span>是否高可用</span
                      ><i class="el-icon-question" @click="showTipsQuestion('ha', '是否高可用')"></i
                    ></template>
                    <el-select v-model="isHighAvailability" placeholder="请选择">
                      <el-option label="否" value="false"></el-option>
                      <el-option label="是" value="true"> </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="text-align: center;">
                    <el-button type="info" @click.native.prevent="handleCalculatorForSegmentScene"
                      >计算服务器资源</el-button
                    >
                    <el-button
                      class="el-button filter-item el-button--default el-button--mini"
                      @click="gotoHomeServerOrderList"
                      size="mini"
                      >返回列表</el-button
                    >
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        v-if="selectSegmentSceneList.length > 0"
        class="backgroud-color-D4D3D0 box"
        :class="{ loading: isLoading }"
        style="width: 100%; "
      >
        <div
          style="width: 100%; display: flex; justify-content: center; 
    align-items: center;margin-top: 10px; height: 50px;"
        >
          <span style="font-size: large; font-weight: bold;"
            >服务器资源计算结果（
            <span style="color:#38a4f5;font-weight: bold; ">计算结果仅供参考，以实际测试为准</span>
            ）<span style="color: orange;text-decoration: underline;" @click="showPrinciple()"
              >点击查看计算原理介绍</span
            >
          </span>
        </div>
        <div style="width: 100%;">
          <el-table
            :key="serverResultKey"
            :data="instCalServerCalculateResultList"
            border
            height="470"
            class="sk-customize-cell-hight"
            style="width: 100%;height: 100%;"
            :span-method="objectSpanMethod"
          >
            <el-table-column prop="specSceneName" label="一级场景" width="120"> </el-table-column>
            <el-table-column prop="terminalModels" label="终端" width="160">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.terminalModels }}
                </span>
                <br />
                <span style="color: #38a4f5;">(桌面总点数： {{ scope.row.desktopNum }}) </span>
              </template>
            </el-table-column>
            <el-table-column prop="serverName" label="服务器" width="120"> </el-table-column>
            <el-table-column prop="calculateServerNum" label="实际节点数量" width="60"> </el-table-column>
            <el-table-column prop="recommendServerNum" label="推荐节点数量" width="60"> </el-table-column>
            <el-table-column prop="cpuName" label="cpu型号" width="160"> </el-table-column>
            <el-table-column prop="cpuNum" label="cpu数量" width="60"> </el-table-column>
            <el-table-column prop="gpuName" label="显卡" width="65"> </el-table-column>
            <el-table-column prop="gpuNum" label="场景显卡总数" width="75"> </el-table-column>
            <el-table-column prop="memorySpecDesc" label="内存规格" width="60"> </el-table-column>
            <el-table-column prop="memoryNum" label="节点内存数量" width="60"> </el-table-column>
            <el-table-column prop="diskInfoList" label="服务器磁盘">
              <template slot-scope="scope">
                <span>
                  <span v-for="(diskInfo, index) in scope.row.diskInfoList" :key="index"> {{ diskInfo }}<br /> </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="localDiskInfo" label="本地存储资源" width="110"> </el-table-column>
            <el-table-column prop="commonDiskInfoList" label="分布式存储资源[场景总磁盘数]">
              <template slot-scope="scope">
                <span>
                  <span v-for="(diskInfo, index) in scope.row.commonDiskInfoList" :key="index">
                    {{ diskInfo }}<br />
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="nicConfig" label="网卡" width="90"> </el-table-column>
          </el-table>
        </div>
        <div v-if="instCalServerCalculateResultList.length > 0" style="background-color:white;padding: 10px 0">
          <!-- <div><span style="color: orange;">温馨提示:</span></div> -->
          <div v-for="(item, index) in instCalServerCalculateResultList" :key="index">
            <div v-if="item.memoryNumErrorDesc !== null" style="color: red; margin-top: 5px;">
              <span>{{ item.specSceneName + '场景：' }}</span>
              <br />
              <span style="margin-left: 20px;">{{ item.memoryNumErrorDesc }}</span>
            </div>
            <div v-if="item.diskNumErrorDesc !== null" style="color: red; margin-top: 5px;">
              <span>{{ item.specSceneName + '场景：' }}</span>
              <br />
              <span style="margin-left: 20px;">{{ item.diskNumErrorDesc }}</span>
            </div>
          </div>
        </div>
        <div
          v-if="instCalServerCalculateResultList.length > 0"
          style="text-align: center; margin-top: 20px; height:100px;"
        >
          <el-button style="margin-top: 10px;" type="info" @click.native.prevent="segmentSceneExport"
            >导出计算结果到Excel</el-button
          >
          <el-button
            class="el-button filter-item el-button--default el-button--mini"
            @click="gotoHomeServerOrderList"
            size="mini"
            >返回列表</el-button
          >
        </div>
        <div v-if="isLoading" class="overlay">
          <div class="loading-text">{{ loadingText }}</div>
        </div>
      </div>
    </div>

    <el-drawer
      ref="drawer"
      :visible="visable"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="closerDrawer"
      direction="rtl"
    >
      <div>
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span>选择桌面资源影响因子</span>
            </template>
          </div>
        </div>
      </div>
      <desktop-element-table
        @addSelect="addSelect"
        :selectedItemArr="specCalDesktopElementDTOList"
      ></desktop-element-table>
    </el-drawer>

    <el-drawer
      ref="drawer"
      :visible="visablePrinciple"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="55%"
      :before-close="closerPrincipleDrawer"
      direction="rtl"
    >
      <div>
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span>计算原理介绍</span>
            </template>
          </div>
        </div>
      </div>
      <div>
        <h4>场景定义：</h4>
        <h4>场景配置：双屏、有杀毒软件、有加密软件</h4>
        <h4>普通中载桌面配置：CPU4核、内存8G、显存1G、系统盘100G、数据盘500G、桌面数100</h4>
        <h4>服务器选中RG-CS6000-G2、CPU：Gold 6326@2.9GHz(16核32线程)*2</h4>
        <h4>GPU选中V520、数量5张</h4>
        <h4>1、计算节点数：</h4>
        <h4>
          一、按CPU计算：100/((32*2)*2.8/4*(1-0.2)(1-0.2))=3.49(4台)(说明：2.8为cpu超分比,0.2是杀毒软件和加密软件要扣除的并发量)
        </h4>
        <h4>二、按GPU计算:100/(5*10/1*(1-0.2)(1-0.2))=3.125(4台)(说明：0.2是杀毒软件和加密软件要扣除的并发量)</h4>
        <h4>所以节点数取两者中的最大值，也就是3.49（取整4台）</h4>
        <h4>
          2、计算内存（开启双屏）：100 * 8.9 + 4 * 80 = 1210 / 4 = 302.5
          (303G)(说明：开启双屏每台内存需要增加0.9G，单屏桌面每台内存需要增加0.55G，
          80G是单台服务器固定需要分配的内存值)
        </h4>
        <h4>
          3、计算存储空间（2D副本策略）：100 * 100 + 500 * 100 + 2000= 62000 / 0.5 = (124000)/ 8000 /4 = 3.875 (4块盘)
          (说明：软件，镜像文件空间预留2T；存储副本策略对应的得盘率0.5,可查看副本策略介绍)
        </h4>

        <h4>
          4.如果有批量开机需求可以结合预启动和定时开机策略来解决开机风暴问题。（重要）
        </h4>
        <h4 style="color: red;">5. 若客户需要配置双系统盘，必须搭载硬件RAID卡！！！</h4>
        <h4>如果节点数算出小于3,同时选择了高可用功能，必须等于3</h4>
        <h4>如遇到该文档中没有的场景需要提交至专业致胜团队--接口人 吴煜彬</h4>
      </div>
    </el-drawer>

    <el-drawer
      ref="drawer"
      :visible="visableTips"
      :modal-append-to-body="false"
      :modal="false"
      :append-to-body="false"
      size="23%"
      :before-close="closerTipsDrawer"
      direction="rtl"
      style="z-index: 1000;"
    >
      <div
        style="margin-top: -70px;margin-bottom: 20px;margin-left: 10px;margin-right: 60px;"
        class="wsp-padding-tb-12"
      >
        <div>
          <div
            style="background: #0052d9;margin: 12px 0;width: 6px;height: 31px;display: inline-block; margin-bottom: -10px;"
          ></div>
          <div style="display: inline-block; margin-bottom: 5px; margin-left: 8px;  font-size: large;">
            <template>
              <span>{{ visableTitle }}</span
              ><span>说明</span>
            </template>
          </div>
        </div>
      </div>
      <div class="drawer-tips">
        <div class="tips-rl-question">相关解释</div>
        <div class="drawer-tips-content">{{ lang.t(visableExplanation) }}</div>
        <div v-if="lang.t(visableQuestion) !== ''" class="tips-rl-question">热点问题</div>
        <div v-if="lang.t(visableQuestion) !== ''" class="drawer-tips-content">{{ lang.t(visableQuestion) }}</div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import {
  Form,
  Input,
  Button,
  Tooltip,
  Radio,
  RadioGroup,
  RadioButton,
  Tabs,
  TabPane,
  Select,
  Option,
  Table,
  TableColumn,
  InputNumber,
  Drawer,
  Steps,
  Step
} from 'element-ui'

import { action } from 'sky-engine/api'
import viewController from 'sky-engine/views/viewController'

import CalServerListDetail from './CalServerListDetail'
import DesktopElementTable from './desktopElementTable'
import ShowSpecialSceneCalType from './ShowSpecialSceneCalType'
import ShowUseCalNotice from './ShowUseCalNotice'

import { CAL_SERVER_ORDER_MNG, CAL_SEGMENT_SCENE_MNG, CAL_GPU_CARD_MNG } from '@/api/apiModules'
import { getIndustryScene } from '@/api/businessResearch'
import {
  createOrUpdate,
  orderDetail,
  desktopResourceCalculate,
  calServerResource,
  getElementRecommend,
  getCalSoftwareList
} from '@/api/calculator'
import lang from '@/lang'

export default {
  name: 'CalculatorController',
  extends: viewController,
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [RadioButton.name]: RadioButton,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [InputNumber.name]: InputNumber,
    [Drawer.name]: Drawer,
    [Steps.name]: Steps,
    [Step.name]: Step,
    DesktopElementTable
  },
  props: {
    views: {
      type: Object,
      default() {
        return {}
      }
    },
    params: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      isShowRadicalModelView: false,
      isRadicalModel: false,
      localDiskComponent: 0,
      isShowLocalDiskView: false,
      localDiskType: null,
      antivirusSoftwareIdArr: [],
      encrpytionSoftwareId: [],
      raidTipsShow: false,
      isNeedGpu: 'true',
      isCalSingleServerVisible: true,
      isCalAllServerVisible: false,
      osTypeList: [],
      selectServerModel: 'single',
      single: 'single',
      all: 'all',
      visablePrinciple: false,
      calResultWarnList: [],
      isLoading: false,
      loadingText: '智能分析中,请稍等...',
      activeStep: 1,
      lang: lang,
      visableTitle: null,
      visableQuestin: null,
      visableTips: false,
      visableExplanation: null,
      visableQuestion: null,
      //计算订单id
      calOrderId: null,
      segmentSceneId: null,
      instSegmentSceneId: null,
      sceneComponentKey: 0,
      serverResultKey: 0,
      desktopResourceKey: 0,
      desktopElementComponentKey: 0,
      //规格行业列表
      specIndustryList: [],
      //用户选择的行业
      selectIndustry: null,
      //细分场景列表
      selectSegmentSceneList: [],
      //----场景对应的计算配置信息-----
      instCalServerElementDTOList: [],
      specCalDesktopElementDTOList: [],
      instCalDesktopResourceDTOList: [],
      //推荐的服务器和cpu
      instCalRecommendServerDTOList: [],
      instCalRecommendCpuDTOList: [],
      specSsdDiskList: [],
      specHddDiskList: [],
      specNvmeDiskList: [],
      specGroupDiskList: [],
      specDiskList: [],
      specCalGpuCardList: [],
      specCalGpuCardDTOList: [],
      serverSystemDiskType: 'SSD_FOUR_HUNDRED_EIGHTY',
      serverSystemDiskCount: '1',
      serverCacheDiskType: 'SSD_FOUR_HUNDRED_EIGHTY',
      serverCacheDiskCount: '2',
      desktopSystemDiskType: 'HDD_EIGHT_T',
      desktopSystemDiskBackUpType: 'SYSTEM_RECOMMEND',
      desktopDataDiskType: 'HDD_EIGHT_T',
      desktopDataDiskBackUpType: 'SYSTEM_RECOMMEND',
      isHighAvailability: 'false',
      cmsSize: 0,
      generateSize: 50,
      selectGpu: null,
      //用户选择的服务器和cpu
      serverResourceDTO: {
        serverId: '',
        cpuConfigId: '',
        cpuNum: '',
        cpuAllocationRatio: ''
      },
      //计算出的服务器资源信息
      instCalServerResourceDTO: {},
      memorySpec: 'THIRTY_TWO',
      backUpType: 'TWO_D',
      //服务器最终计算得服务器列表
      instCalServerCalculateResultList: [],
      //加密软件
      encrpytionSoftwareList: [],
      //杀毒软件
      antivirusSoftwareList: [],
      //-----场景对应的计算配置信息----
      activeName: '',
      //第一个表单
      firstForm: {
        customerName: '',
        industryId: ''
      },
      firstRules: {
        customerName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
        industryId: [{ required: true, message: '请选择行业', trigger: 'change' }]
      },
      visable: false
    }
  },
  created() {
    this.getInitData()
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    highIoChange(type, content) {
      if (content === 'true') {
        this.specGroupDiskList = this.specSsdDiskList.concat(this.specNvmeDiskList)
        this.localDiskType = 'SSD_FOUR_HUNDRED_EIGHTY'
      } else {
        this.specGroupDiskList = this.specDiskList
        this.localDiskType = 'HDD_EIGHT_T'
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      var resultSize = this.instCalServerCalculateResultList.length
      if (columnIndex === 13) {
        if (rowIndex % resultSize === 0) {
          return {
            rowspan: resultSize,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    showSpecialSceneCalType() {
      var data = {}
      //弹框
      var dialog = this.$dialog({
        template: h => {
          return (
            <show-special-scene-cal-type
              data={data}
              onCb={function() {
                dialog.remove()
                dialog.component.$parent.$parent.reloadData()
              }}
              onConfirm={function(data) {
                dialog.remove()
              }}
            ></show-special-scene-cal-type>
          )
        },
        components: {
          ShowSpecialSceneCalType
        },
        props: {
          title: '共享应用虚拟化，共享桌面场景服务器资源计算介绍',
          width: '75%',
          'custom-class': 'custom-change-detail-dialog',
          showCancelBtn: false, // 隐藏取消按钮
          showClose: true, // 隐藏关闭按钮
          showDefaultFooter: false, //隐藏确定和取消按钮
          closeOnPressEscape: false, // 不能通过ESC键关闭
          closeOnHashChange: false // 不能通过路由改变关闭
        }
      })
    },
    showUseCalNotice() {
      var data = {}
      //弹框
      var dialog = this.$dialog({
        template: h => {
          return (
            <show-use-cal-notice
              data={data}
              onCb={function() {
                dialog.remove()
                dialog.component.$parent.$parent.reloadData()
              }}
              onConfirm={function(data) {
                dialog.remove()
              }}
            ></show-use-cal-notice>
          )
        },
        components: {
          ShowUseCalNotice
        },
        props: {
          title: '服务器资源配置器参考资料',
          width: '70%',
          'custom-class': 'custom-change-detail-dialog',
          showCancelBtn: false, // 隐藏取消按钮
          showClose: true, // 隐藏关闭按钮
          showDefaultFooter: false, //隐藏确定和取消按钮
          closeOnPressEscape: false, // 不能通过ESC键关闭
          closeOnHashChange: false // 不能通过路由改变关闭
        }
      })
    },
    selectSystemDiskCountChange(item) {
      if (item === '1') {
        this.raidTipsShow = false
      }
      if (item === '2') {
        this.raidTipsShow = true
      }
    },
    selectServerModelChange() {
      if (this.selectServerModel === 'single') {
        this.isCalSingleServerVisible = true
        this.isCalAllServerVisible = false
      } else {
        this.isCalSingleServerVisible = false
        this.isCalAllServerVisible = true
        this.serverResourceDTO.cpuNum = 2

        var isNeedGPU = false
        this.instCalDesktopResourceDTOList.forEach(item => {
          if (item.videoMemory > 0) {
            isNeedGPU = true
          }
        })
        if (isNeedGPU) {
          this.isNeedGpu = 'true'
        } else {
          this.isNeedGpu = 'false'
        }
      }
    },
    desktopNumChange() {
      var isQy = false
      this.specIndustryList.forEach(item => {
        if (this.firstForm.industryId === item.id && item.industryCode === 'QY') {
          isQy = true
        }
      })
      if (!isQy) {
        return
      }
      var allDeskTopNum = 0
      this.instCalDesktopResourceDTOList.forEach(item => {
        allDeskTopNum += item.desktopNum
      })

      if (allDeskTopNum >= 200) {
        this.isShowRadicalModelView = true
      } else {
        this.isShowRadicalModelView = false
        this.isRadicalModel = false
      }
    },
    selectOsType(item, row) {
      this.instCalDesktopResourceDTOList.forEach(obj => {
        obj.cpuSpeed = row.cpuSpeed
        obj.osTypeId = row.osTypeId
      })

      const instCalDesktopResourceList = this.instCalDesktopResourceDTOList.filter(item => {
        if (item.osTypeId) {
          return item
        }
      })
      const osTypeIdList = instCalDesktopResourceList
        .map(item => item.osTypeId)
        .filter((value, index, self) => self.indexOf(value) === index)

      var maxCpuSpeed = 0.0
      instCalDesktopResourceList.forEach(item => {
        if (item.cpuSpeed > maxCpuSpeed) {
          maxCpuSpeed = item.cpuSpeed
        }
      })

      if (!osTypeIdList || osTypeIdList.length == 0) {
        this.$store.dispatch('OpenNotification', {
          message: '请先选择桌面操作系统',
          type: 'error'
        })
        return
      }

      const data = {
        segmentSceneId: item.segmentSceneId,
        maxCpuSpeed: maxCpuSpeed,
        osTypeList: osTypeIdList
      }
      action(CAL_SEGMENT_SCENE_MNG, '/server/recommend', data).then(res => {
        this.serverResourceDTO.serverId = null
        this.serverResourceDTO.cpuConfigId = null
        this.serverResourceDTO.cpuNum = null
        this.instCalRecommendServerDTOList = res.data.content
        this.instCalRecommendCpuDTOList = []
        if (res.data.content.length == 0) {
          this.$store.dispatch('OpenNotification', {
            message: '未查询到匹配的服务器，可能cpu主频过高或者操作系统不支持',
            type: 'error'
          })
          return
        }
      })
    },
    getOsTypeList() {
      var data = {
        id: this.segmentSceneId
      }
      action(CAL_SEGMENT_SCENE_MNG, 'osType/list', data).then(response => {
        this.osTypeList = response.data.content
      })
    },
    getInitData() {
      this.antivirusSoftwareList = []
      getCalSoftwareList().then(res => {
        res.data.content.itemArr.forEach(item => {
          if (item.softwareType === 'ENCRPYTION') {
            this.encrpytionSoftwareList.push(item)
          }
          if (item.softwareType === 'ANTIVIRUS') {
            this.antivirusSoftwareList.push(item)
          }
        })
      })

      this.firstForm.sceneSegmentSceneDTOList = [{ sceneId: null, segmentSceneId: null }]
      this.sceneComponentKey += 1
      getIndustryScene({}).then(res => {
        this.specIndustryList = res.data.content.specIndustry.filter(item => {
          return item.industryCode === 'QY' || item.industryCode === 'YL' || item.industryCode === 'GJ'
        })

        this.firstForm.industryId = this.specIndustryList[0].id
        this.sceneComponentKey += 1
        this.calOrderId = this.views.params.id
        if (this.calOrderId) {
          this.initOrderDetail()
        }
      })
    },
    initOrderDetail() {
      orderDetail({ id: this.calOrderId }).then(res => {
        this.firstForm.industryId = res.data.content.industryId
        this.firstForm.customerName = res.data.content.customerName
        this.firstForm.sceneSegmentSceneDTOList = res.data.content.sceneSegmentSceneDTOList.map(item => {
          return {
            sceneId: item.sceneId,
            segmentSceneId: item.segmentSceneId,
            sceneName: item.sceneName
          }
        })
        this.sceneComponentKey += 1
        this.initSelectSegmentCalDetail(res)
        this.desktopNumChange()
      })
    },
    changeTrade(selectItem) {
      this.selectIndustry = selectItem
      this.firstForm.industryId = selectItem
      this.firstForm.sceneSegmentSceneDTOList = [{ sceneId: null, segmentSceneId: null }]
      this.sceneComponentKey += 1
      //重新渲染 选择场景的组件
    },
    handleChildSceneSegmentSceneRela(relateList) {
      this.firstForm.sceneSegmentSceneDTOList = relateList
    },
    copyDesktopResource(row) {
      var newRow = {
        dataFrom: 'USER_ADD',
        cpuSpeed: row.cpuSpeed,
        cpuCore: row.cpuCore,
        videoMemory: row.videoMemory,
        memory: row.memory,
        iops: row.iops,
        instSegmentSceneId: row.instSegmentSceneId,
        desktopNum: 0,
        systemDiskSize: row.systemDiskSize,
        dataDiskSize: row.dataDiskSize,
        osTypeId: row.osTypeId
      }
      this.instCalDesktopResourceDTOList.push(newRow)
    },
    deleteRow(index, rows) {
      rows.splice(index, 1)
    },
    async handleTabClick() {
      var data = {
        id: this.calOrderId
      }
      orderDetail(data).then(res => {
        this.initSelectSegmentCalDetail(res)
      })
    },
    initSelectSegmentCalDetail(res) {
      this.isOpen = true
      this.selectSegmentSceneList = this.firstForm.sceneSegmentSceneDTOList
      if (this.activeName === '' || this.activeName === '0') {
        this.activeName = this.selectSegmentSceneList[0].sceneName
        this.segmentSceneId = this.selectSegmentSceneList[0].segmentSceneId
      }
      this.instCalServerCalculateResultList = []
      res.data.content.sceneSegmentSceneDTOList.forEach(item => {
        if (item.instCalDetailConfigDTO.instCalServerResourceDTO !== null) {
          this.instCalServerCalculateResultList.push(item.instCalDetailConfigDTO.instCalServerResourceDTO)
        }
        if (item.sceneName === this.activeName) {
          var instCalDetailConfigDTO = item.instCalDetailConfigDTO
          this.segmentSceneId = item.segmentSceneId
          this.getOsTypeList()
          this.instSegmentSceneId = item.id
          this.instCalServerElementDTOList = instCalDetailConfigDTO.instCalServerElementDTOList
          this.instCalServerElementDTOList.forEach(item => {
            if (item.type === 'DESKTOP_TYPE' && item.content === 'RESTORE') {
              this.isShowLocalDiskView = true
            }
          })
          this.specCalDesktopElementDTOList = instCalDetailConfigDTO.specCalDesktopElementDTOList
          if (instCalDetailConfigDTO.antivirusSoftwareIdArr) {
            this.antivirusSoftwareIdArr = instCalDetailConfigDTO.antivirusSoftwareIdArr
          } else {
            this.antivirusSoftwareIdArr = []
          }
          if (instCalDetailConfigDTO.encrpytionSoftwareId) {
            this.encrpytionSoftwareId = instCalDetailConfigDTO.encrpytionSoftwareId
          } else {
            this.encrpytionSoftwareId = null
          }

          this.desktopElementComponentKey += 1
          this.instCalDesktopResourceDTOList = instCalDetailConfigDTO.instCalDesktopResourceDTOList
          this.desktopResourceKey += 1
          this.instCalRecommendServerDTOList = instCalDetailConfigDTO.instCalRecommendServerDTOList

          this.instCalRecommendCpuDTOList = []
          this.specDiskList = instCalDetailConfigDTO.specDiskList
          this.specHddDiskList = this.specDiskList.filter(item => item.id.startsWith('HDD'))
          this.specNvmeDiskList = this.specDiskList.filter(item => item.id.startsWith('NVME'))
          this.specSsdDiskList = this.specDiskList.filter(item => item.id.startsWith('SSD'))

          this.specGroupDiskList = this.specDiskList
          this.localDiskType = 'HDD_EIGHT_T'
          this.instCalServerElementDTOList.forEach(item => {
            if (item.type === 'HIGH_IO' && item.content === 'true') {
              this.specGroupDiskList = this.specSsdDiskList.concat(this.specNvmeDiskList)
              this.localDiskType = 'SSD_FOUR_HUNDRED_EIGHTY'
            }
          })
          this.localDiskComponent += 1

          if (instCalDetailConfigDTO.instCalLocalDiskResourceDTO) {
            this.localDiskType = instCalDetailConfigDTO.instCalLocalDiskResourceDTO.diskSpec
            this.generateSize = instCalDetailConfigDTO.instCalLocalDiskResourceDTO.generateSize
          }

          this.specCalGpuCardDTOList = instCalDetailConfigDTO.specCalGpuCardDTOList
          this.specCalGpuCardList = instCalDetailConfigDTO.specCalGpuCardDTOList

          if (!instCalDetailConfigDTO.instCalServerResourceDTO) {
            this.serverSystemDiskType = 'SSD_FOUR_HUNDRED_EIGHTY'
            this.serverSystemDiskCount = '1'
            this.serverCacheDiskType = 'SSD_FOUR_HUNDRED_EIGHTY'
            this.serverCacheDiskCount = '2'
            this.desktopSystemDiskType = 'HDD_EIGHT_T'
            this.desktopSystemDiskBackUpType = 'SYSTEM_RECOMMEND'
            this.desktopDataDiskType = 'HDD_EIGHT_T'
            this.desktopDataDiskBackUpType = 'SYSTEM_RECOMMEND'
            this.selectGpu = null
            this.memorySpec = 'THIRTY_TWO'
            this.backUpType = 'TWO_D'

            if (this.instCalRecommendServerDTOList !== null && this.instCalRecommendServerDTOList.length === 1) {
              this.serverResourceDTO = {
                serverId: this.instCalRecommendServerDTOList[0].id,
                cpuConfigId: null,
                cpuNum: null,
                cpuAllocationRatio: null
              }
              this.selectServer(this.instCalRecommendServerDTOList[0].id)
            } else {
              this.serverResourceDTO = {
                serverId: null,
                cpuConfigId: null,
                cpuNum: null,
                cpuAllocationRatio: null
              }
            }
          } else {
            this.serverResourceDTO.serverId = instCalDetailConfigDTO.instCalServerResourceDTO.serverId
            this.selectServer(this.serverResourceDTO.serverId)
            this.serverResourceDTO.cpuConfigId = instCalDetailConfigDTO.instCalServerResourceDTO.cpuConfigId
            this.serverResourceDTO.cpuNum = instCalDetailConfigDTO.instCalServerResourceDTO.cpuNum
            this.serverResourceDTO.cpuAllocationRatio =
              instCalDetailConfigDTO.instCalServerResourceDTO.cpuAllocationRatio
            this.isRadicalModel = instCalDetailConfigDTO.instCalServerResourceDTO.isRadicalModel

            this.selectGpu = instCalDetailConfigDTO.instCalServerResourceDTO.gpuId

            if (instCalDetailConfigDTO.instCalServerResourceDTO) {
              var diskResourceList = instCalDetailConfigDTO.instCalServerResourceDTO.instCalServerDiskResourceDTOList
              if (diskResourceList.length > 0) {
                diskResourceList.forEach(item => {
                  if (item.usageType === 'SERVER_SYSTEM') {
                    this.serverSystemDiskType = item.diskSpec
                    this.serverSystemDiskCount = item.diskNum
                  }
                  if (item.usageType === 'SERVER_CACHE') {
                    this.serverCacheDiskType = item.diskSpec
                    this.serverDataDiskCount = item.diskNum
                  }
                })
              }
            }

            if (instCalDetailConfigDTO.instCalCommonDiskResourceDTOList.length > 0) {
              var commonDiskResourceList = instCalDetailConfigDTO.instCalCommonDiskResourceDTOList
              if (commonDiskResourceList.length > 0) {
                commonDiskResourceList.forEach(item => {
                  if (item.usageType === 'DESKTOP_SYSTEM') {
                    this.desktopSystemDiskType = item.diskSpec
                    this.desktopSystemDiskBackUpType = item.webBackupModel
                  }
                  if (item.usageType === 'DESKTOP_DATA') {
                    this.desktopDataDiskType = item.diskSpec
                    this.desktopDataDiskBackUpType = item.webBackupModel
                  }
                })
              }
            }

            if (instCalDetailConfigDTO.instCalClusterConfigDTO) {
              this.cmsSize = instCalDetailConfigDTO.instCalClusterConfigDTO.cmsSize
              if (instCalDetailConfigDTO.instCalClusterConfigDTO.isHighAvailability) {
                this.isHighAvailability = 'true'
              } else {
                this.isHighAvailability = 'false'
              }
            }
            this.memorySpec = instCalDetailConfigDTO.instCalServerResourceDTO.memorySpec
          }
        }
      })
    },
    selectServer(serverId) {
      const selectedServer = this.instCalRecommendServerDTOList.find(item => item.id === serverId)
      if (selectedServer) {
        this.serverResourceDTO.cpuConfigId = null
        this.serverResourceDTO.cpuNum = 2
        this.instCalRecommendCpuDTOList = selectedServer.instCalRecommendCpuDTOList
        this.initGpuInfo()
      }
    },
    selectCpuNumChange(item) {
      if (this.selectServerModel === 'single') {
        this.initGpuInfo()
      }
    },
    initGpuInfo() {
      this.serverResourceDTO.serverId
      const data = {
        serverId: this.serverResourceDTO.serverId,
        cpuNum: this.serverResourceDTO.cpuNum
      }
      action(CAL_GPU_CARD_MNG, 'usable/list', data).then(res => {
        this.specCalGpuCardDTOList = res.data.content
        if (this.specCalGpuCardDTOList.length > 0) {
          const exists = this.specCalGpuCardDTOList.some(item => item.id === this.selectGpu)

          if (!exists) {
            this.selectGpu = null
          }
        }
      })
    },
    selectCpuChange(cpuId) {
      this.instCalRecommendCpuDTOList.forEach(item => {
        if (item.id === cpuId) {
          this.serverResourceDTO.cpuAllocationRatio = item.cpuAllocationRatio
        }
      })
      this.serverResourceDTO.cpuNum = 2
    },
    onSubmit(formName) {
      var checkOk = true
      this.$refs[formName].validate(valid => {
        if (!valid) {
          checkOk = false
        }
      })
      if (!checkOk) {
        return
      }
      this.selectSegmentSceneList = this.firstForm.sceneSegmentSceneDTOList

      //保存表单
      var data = {
        id: this.calOrderId,
        customerName: this.firstForm.customerName,
        industryId: this.firstForm.industryId,
        sceneSegmentSceneDTOList: this.firstForm.sceneSegmentSceneDTOList
      }
      createOrUpdate(data).then(res => {
        this.calOrderId = res.data.content
        this.initOrderDetail()
      })
    },
    handleCalculatorForSegmentScene() {
      if (this.selectServerModel === 'single') {
        //手动选择服务器计算
        this.handlecalculator()
        return
      }

      var osTypeCheck = true
      this.instCalDesktopResourceDTOList.forEach(item => {
        if (!item.osTypeId) {
          osTypeCheck = false
        }
      })

      if (!osTypeCheck) {
        this.$store.dispatch('OpenNotification', { message: '桌面模版请选择桌面操作系统', type: 'error' })
        return
      }

      if (!this.serverResourceDTO.cpuNum) {
        this.$store.dispatch('OpenNotification', { message: '服务器CPU数量请选择', type: 'error' })
        return
      }

      var videoMemory = 0.0
      this.instCalDesktopResourceDTOList.forEach(item => {
        videoMemory = item.videoMemory
      })

      if (videoMemory > 0.0 && this.isNeedGpu === 'false') {
        this.$store.dispatch('OpenNotification', {
          message: '桌面模版有配置GPU显存，是否需要GPU必须选择【是】',
          type: 'error'
        })
        return
      }

      if (!this.isShowLocalDiskView) {
        this.localDiskType = null
      }

      var data = {
        calOrderId: this.calOrderId,
        instSegmentSceneId: this.instSegmentSceneId,
        isRadicalModel: this.isRadicalModel,
        serverResourceDTO: {
          serverId: this.serverResourceDTO.serverId,
          cpuConfigId: this.serverResourceDTO.cpuConfigId,
          cpuNum: this.serverResourceDTO.cpuNum,
          cpuAllocationRatio: this.serverResourceDTO.cpuAllocationRatio,
          gpuId: this.selectGpu,
          isNeedGpu: this.isNeedGpu,
          memorySpec: this.memorySpec,
          cmsSize: this.cmsSize,
          instCalServerDiskResourceDTOList: [
            { usageType: 'SERVER_SYSTEM', diskSpec: this.serverSystemDiskType, diskNum: this.serverSystemDiskCount },
            { usageType: 'SERVER_CACHE', diskSpec: this.serverCacheDiskType, diskNum: this.serverCacheDiskCount }
          ]
        },
        instCalCommonDiskResourceDTOList: [
          {
            usageType: 'DESKTOP_SYSTEM',
            diskSpec: this.desktopSystemDiskType,
            diskNum: 0,
            webBackupModel: this.desktopSystemDiskBackUpType
          },
          {
            usageType: 'DESKTOP_DATA',
            diskSpec: this.desktopDataDiskType,
            diskNum: 0,
            webBackupModel: this.desktopDataDiskBackUpType
          }
        ],
        instCalClusterConfigDTO: {
          cmsSize: this.cmsSize,
          isHighAvailability: this.isHighAvailability
        },
        instCalLocalDiskResourceDTO: {
          diskSpec: this.localDiskType,
          generateSize: this.generateSize
        },
        instCalServerElementDTOList: this.instCalServerElementDTOList,
        instCalDesktopResourceDTOList: this.instCalDesktopResourceDTOList,
        antivirusSoftwareIdArr: this.antivirusSoftwareIdArr,
        encrpytionSoftwareId: this.encrpytionSoftwareId
      }
      //弹框
      const _this = this
      var dialog = this.$dialog({
        template: h => {
          return (
            <cal-server-list-detail
              data={data}
              onCb={function() {
                dialog.remove()
                dialog.component.$parent.$parent.reloadData()
              }}
              onConfirm={function(data) {
                dialog.remove()

                _this.serverResourceDTO.serverId = data.data[0].serverId
                _this.serverResourceDTO.cpuConfigId = data.data[0].cpuConfigId
                _this.serverResourceDTO.cpuNum = data.data[0].cpuNum
                _this.selectGpu = data.data[0].gpuId
                _this.handlecalculator()
              }}
            ></cal-server-list-detail>
          )
        },
        components: {
          CalServerListDetail
        },
        props: {
          title: '服务器资源计算结果列表',
          width: '90%',
          'custom-class': 'custom-change-detail-dialog',
          showCancelBtn: false, // 隐藏取消按钮
          showClose: true, // 隐藏关闭按钮
          showDefaultFooter: false, //隐藏确定和取消按钮
          closeOnPressEscape: false, // 不能通过ESC键关闭
          closeOnHashChange: false // 不能通过路由改变关闭
        }
      })
    },
    handlecalculator() {
      var osTypeCheck = true
      this.instCalDesktopResourceDTOList.forEach(item => {
        if (!item.osTypeId) {
          osTypeCheck = false
        }
      })

      if (!osTypeCheck) {
        this.$store.dispatch('OpenNotification', { message: '桌面模版请选择桌面操作系统', type: 'error' })
        return
      }

      if (this.serverResourceDTO.serverId === null) {
        this.$store.dispatch('OpenNotification', { message: '请选择一种服务器', type: 'error' })
        return
      }
      if (this.serverResourceDTO.cpuConfigId === null) {
        this.$store.dispatch('OpenNotification', { message: '请选择服务器对应的cpu', type: 'error' })
        return
      }

      var videoMemory = 0.0
      this.instCalDesktopResourceDTOList.forEach(item => {
        videoMemory = item.videoMemory
      })
      if (videoMemory > 0 && !this.selectGpu) {
        this.$store.dispatch('OpenNotification', { message: '请选择GPU显卡', type: 'error' })
        return
      }

      if (this.selectGpu) {
        this.isNeedGpu = 'true'
      } else {
        this.isNeedGpu = 'false'
      }

      if (!this.isShowLocalDiskView) {
        this.localDiskType = null
      }

      var data = {
        calOrderId: this.calOrderId,
        instSegmentSceneId: this.instSegmentSceneId,
        isRadicalModel: this.isRadicalModel,
        serverResourceDTO: {
          serverId: this.serverResourceDTO.serverId,
          cpuConfigId: this.serverResourceDTO.cpuConfigId,
          cpuAllocationRatio: this.serverResourceDTO.cpuAllocationRatio,
          cpuNum: this.serverResourceDTO.cpuNum,
          gpuId: this.selectGpu,
          isNeedGpu: this.isNeedGpu,
          memorySpec: this.memorySpec,
          instCalServerDiskResourceDTOList: [
            { usageType: 'SERVER_SYSTEM', diskSpec: this.serverSystemDiskType, diskNum: this.serverSystemDiskCount },
            { usageType: 'SERVER_CACHE', diskSpec: this.serverCacheDiskType, diskNum: this.serverCacheDiskCount }
          ]
        },
        instCalCommonDiskResourceDTOList: [
          {
            usageType: 'DESKTOP_SYSTEM',
            diskSpec: this.desktopSystemDiskType,
            diskNum: 0,
            webBackupModel: this.desktopSystemDiskBackUpType
          },
          {
            usageType: 'DESKTOP_DATA',
            diskSpec: this.desktopDataDiskType,
            diskNum: 0,
            webBackupModel: this.desktopDataDiskBackUpType
          }
        ],
        instCalClusterConfigDTO: {
          cmsSize: this.cmsSize,
          isHighAvailability: this.isHighAvailability
        },
        instCalLocalDiskResourceDTO: {
          diskSpec: this.localDiskType,
          generateSize: this.generateSize
        },
        instCalServerElementDTOList: this.instCalServerElementDTOList,
        instCalDesktopResourceDTOList: this.instCalDesktopResourceDTOList,
        antivirusSoftwareIdArr: this.antivirusSoftwareIdArr,
        encrpytionSoftwareId: this.encrpytionSoftwareId
      }
      //计算中
      this.isLoading = true
      calServerResource(data).then(res => {
        this.instCalServerCalculateResultList = res.data.content
        this.isLoading = false
      })
    },
    desktopTypeChange(key) {
      if (key === 'RESTORE') {
        this.isShowLocalDiskView = true
        this.localDiskType = 'HDD_EIGHT_T'
      } else {
        this.isShowLocalDiskView = false
        this.localDiskType = null
      }
    },
    renderingChange(type, key) {
      var data = {
        elementType: type,
        key: key
      }
      getElementRecommend(data).then(res => {
        var specGpuIdList = res.data.content.map(item => {
          return item.id
        })
        this.specCalGpuCardDTOList = this.specCalGpuCardList.filter(item => specGpuIdList.includes(item.id))

        if (this.specCalGpuCardDTOList.length === 1) {
          this.selectGpu = this.specCalGpuCardDTOList[0].id
          this.selectGpuChange(this.selectGpu)
        } else {
          this.selectGpu = null
        }
      })
    },
    getDesktopElementList() {
      this.visable = true
    },
    closerDrawer() {
      this.visable = false
    },
    addSelect(params) {
      for (const iterator of params.select) {
        const exists = this.specCalDesktopElementDTOList.some(obj => obj.id === iterator.id)
        if (exists) {
          this.visable = false
          continue
        }
        this.specCalDesktopElementDTOList.splice(0, 0, {
          id: iterator.id,
          name: iterator.name,
          softVersion: iterator.softVersion,
          workScene: iterator.workScene,
          typeDesc: iterator.typeDesc,
          materialDesc: iterator.materialDesc,
          cpuSpeed: iterator.cpuSpeed,
          cpuCore: iterator.cpuCore,
          videoMemory: iterator.videoMemory,
          memory: iterator.memory,
          systemDiskSize: iterator.systemDiskSize,
          dataDiskSize: iterator.dataDiskSize,
          iops: iterator.iops
        })
      }
      this.closerDrawer()
      //重新计算
      this.desktopResourceCalculate()
    },
    removeDesktopElement(row, index) {
      this.specCalDesktopElementDTOList.splice(index, 1)
      //重新计算
      this.desktopResourceCalculate()
    },
    gotoHomeServerOrderList() {
      this.activiteViewPage = null
      this.$store.dispatch('ReturnPage')
    },
    desktopResourceCalculate() {
      var desktopElementIdList = this.specCalDesktopElementDTOList.map(item => {
        return item.id
      })
      if (desktopElementIdList.length === 0) {
        return
      }
      var data = {
        instSegmentSceneId: this.instSegmentSceneId,
        specCalDesktopElementIdList: desktopElementIdList
      }
      desktopResourceCalculate(data).then(res => {
        this.instCalDesktopResourceDTOList.forEach(item => {
          item.cpuSpeed = res.data.content.cpuSpeed
          item.cpuCore = res.data.content.cpuCore
          item.videoMemory = res.data.content.videoMemory
          item.memory = res.data.content.memory
          item.iops = res.data.content.iops
          item.systemDiskSize = res.data.content.systemDiskSize
          item.dataDiskSize = res.data.content.dataDiskSize
        })
      })
    },
    showTipsQuestion(tipLabel, title) {
      this.visableTips = true
      this.visableExplanation = 'tips.explanation.' + tipLabel
      this.visableQuestion = 'tips.question.' + tipLabel
      this.visableTitle = title
    },
    showPrinciple() {
      this.visablePrinciple = true
    },
    closerPrincipleDrawer() {
      this.visablePrinciple = false
    },
    closerTipsDrawer() {
      this.visableTips = false
    },
    segmentSceneExport() {
      const url = `wsp/${CAL_SERVER_ORDER_MNG}/export?id=${this.calOrderId}` // 构造下载链接
      // 使用 window.open 下载文件
      window.open(url, '_blank')
    },
    cpuSpeedChange(cpuSpeed) {
      this.instCalDesktopResourceDTOList.forEach(item => {
        item.videoMemory = cpuSpeed
      })
    },
    videoMemoryChange(videoMemory) {
      var isNeedGPU = false
      if (videoMemory > 0) {
        isNeedGPU = true
      }

      if (isNeedGPU) {
        this.isNeedGpu = 'true'
      } else {
        this.isNeedGpu = 'false'
        this.selectGpu = null
      }
    },
    handleScroll() {
      // 获取当前滚动位置
      const scrollPosition = this.$refs.scrollContainer.scrollTop
      if (scrollPosition > 0 && scrollPosition <= 300) {
        this.activeStep = 1
      } else if (scrollPosition > 300 && scrollPosition <= 700) {
        this.activeStep = 2
      } else if (scrollPosition > 700 && scrollPosition <= 1150) {
        this.activeStep = 3
      } else if (scrollPosition > 1150 && scrollPosition <= 1310) {
        this.activeStep = 4
      } else if (scrollPosition > 1400 && scrollPosition <= 1480) {
        this.activeStep = 5
      } else if (scrollPosition > 1480) {
        this.activeStep = 6
      }
    }
  }
}
</script>

<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';

.drawer-tips {
  padding: 12px 24px;
  .tips-rl-question {
    padding-top: 12px;
    margin-bottom: 12px;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.9);
  }
  .drawer-tips-content {
    word-break: break-word;
    white-space: pre-wrap;
    line-height: 24px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
  }
}
.scrollable-div {
  max-height: 70%; /* 设置最大高度 */
  overflow-y: auto; /* 添加垂直滚动条 */
  border: 1px solid #ccc; /* 可选：边框样式 */
  padding: 10px; /* 可选：内边距 */
}
.container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  margin-bottom: 10px;
}

.item {
  flex: 0.3; /* 每个元素的最小宽度为 100px */
  margin: 1px; /* 元素之间的间距 */
  padding: 1px; /* 内边距 */
  box-sizing: border-box; /* 包含内边距和边框 */
}
.gradient-border {
  border: 5px solid transparent; /* 设置透明边框 */
  padding: 20px;
  margin: 10px;
  background-image: linear-gradient(white, white), linear-gradient(white, white);
  background-clip: padding-box, border-box; /* 使背景渐变显示在边框内 */
  border-radius: 10px; /* 圆角 */
}

.cal-table .td {
  padding: 0px !important;
}
.cal-table .cell {
  line-height: 18px;
  min-height: 18px;
  height: 100% !important;
  padding: 0 !important;
}
.cal-table .cell .el-input-number {
  width: 95% !important;
}

.drawer {
  position: absolute;
  bottom: -350px; /* 根据需要调整高度 */
  height: 350px; /* 抽屉的高度 */
  background: #f0f0f0;
  transition: bottom 0.3s ease; /* 动画效果 */
}

.el-select {
  width: 320px !important;
}

.box {
  position: relative;
  width: 100%; /* 设置宽度 */
  //border: 1px solid #ccc; /* 可选：边框样式 */
  //background-color: #f9f9f9; /* 可选：背景颜色 */
  //cursor: pointer; /* 鼠标样式 */
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5); /* 半透明黑色 */
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px;
}

.loading-text {
  text-align: center;
}
</style>
